/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { accessTokenResponseV4ApiResponseObjectV4Schema } from './accessTokenResponseV4ApiResponseObjectV4Schema'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { resetPasswordRequestV4Schema } from './resetPasswordRequestV4Schema'

export const authPasswordResetStatus200Schema =
  accessTokenResponseV4ApiResponseObjectV4Schema.describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )

export const authPasswordResetStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authPasswordResetResponseSchema = authPasswordResetStatus200Schema

export const authPasswordResetErrorSchema = authPasswordResetStatus400Schema

export const authPasswordResetBodySchemaJsonPatchJson = resetPasswordRequestV4Schema.optional()

export const authPasswordResetBodySchemaJson = resetPasswordRequestV4Schema.optional()

export const authPasswordResetBodySchemaJson2 = resetPasswordRequestV4Schema.optional()

export const authPasswordResetBodySchemaJson3 = resetPasswordRequestV4Schema.optional()

export const authPasswordResetBodySchema = z.union([
  authPasswordResetBodySchemaJsonPatchJson,
  authPasswordResetBodySchemaJson,
  authPasswordResetBodySchemaJson2,
  authPasswordResetBodySchemaJson3,
])
